import { render, staticRenderFns } from "./AcademyPage.vue?vue&type=template&id=15e64638"
import script from "./AcademyPage.vue?vue&type=script&lang=js"
export * from "./AcademyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports